const formatSingleDigitAsDoubleDigit = (num) => {
  const numAsString = `${num}`
  if (numAsString.length === 1) {
    return `0${numAsString}`
  }
  return numAsString
}

export const formatDateForServer = (date) => {
  if (!date || !date instanceof Date || isNaN(date)) {
    return null
  }

  // make the date unaware of time and timezone before running the `toJSON` method, which sets the time to UTC and can reset the date to the previous or next day, depending on time of entry.
  const day = date.getDate()
  const month = date.getMonth() + 1 // add 1 to month because months are 0-indexed (January === 0, February === 1)
  const year = date.getFullYear()
  const formattedDate = `${year}-${formatSingleDigitAsDoubleDigit(month)}-${formatSingleDigitAsDoubleDigit(day)}`
  return formattedDate
}

export const formatDateTimeForServer = (date) => {
  if (!date || !date instanceof Date || isNaN(date)) {
    return null
  }
  date = date.toISOString()
  return new Date(date).toJSON()
}

export const parseDateTimeFromServer = (dateStr) => {
  if (!dateStr) {
    return null
  }
  return new Date(dateStr)
}

export const formatTimeForServer = (date) => {
  if (!date) {
    return null
  }
  return date.getHours() + ':' + date.getMinutes()
}

export const parseTimeFromServer = (time) => {
  if (!time) {
    return null
  }
  const hours = time.split(":")[0]
  const minutes = time.split(":")[1]
  const date = new Date()
  date.setHours(hours)
  date.setMinutes(minutes)
  return date
}

export const parseDateFromServer = (dateStr) => {
  if (!dateStr) {
    return null
  }

  const splitDate = dateStr.split('-')
  const year = splitDate[0]
  const month = Number(splitDate[1]) - 1
  const day = splitDate[2]

  return new Date(year, month, day)
}

export const showPatientConsentForm = (createdDate) => {
  // start on June 23, 2022
  const startDateForPatientConsentForm = new Date(2022, 5, 23)
  // return true and show consent form if chart was created on or after start date
  return !createdDate || startDateForPatientConsentForm.valueOf() <= new Date(createdDate).valueOf()
}
